import request from "../../utils/request";

export const state = {
  cityList: [],
};

export const getters = {
  cityList: (state) => {
    return state.cityList;
  },
};

export const mutations = {
  SET_CITY_LIST(state, data) {
    state.cityList = data;
  },
};

export const actions = {
  getCities({ dispatch, commit }) {
    return request({
      url: appUrl + "/api/city_district",
      callBack: (type, value) => {
        if (type === "success") {
          return commit("SET_CITY_LIST", value?.data?.data);
        } else if (type === "error") {
          return commit("SET_CITY_LIST", []);
        }
      },
    });
  },
};
